import { render, staticRenderFns } from "./dxy-steps.vue?vue&type=template&id=81d8e530&"
import script from "./dxy-steps.vue?vue&type=script&lang=js&"
export * from "./dxy-steps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dxy-steps.vue"
export default component.exports